export function activeChildItem(state: any, uiProps: any) {
  return {
    activeChildItem: uiProps.hostProps().activeChildItem
  };
}
